// extracted by mini-css-extract-plugin
export default {"pageHeight":"DioRxProcessing__pageHeight__ResBu","logo":"DioRxProcessing__logo__NQ6Ju","corpLogo":"DioRxProcessing__corpLogo__MkgjP","toolTip":"DioRxProcessing__toolTip__BD0Lt","marginRight8":"DioRxProcessing__marginRight8__Z29mS","marginLeft8":"DioRxProcessing__marginLeft8__rklSN","leftContainer":"DioRxProcessing__leftContainer__KSFrT","rightContainer":"DioRxProcessing__rightContainer__wOPzZ"};
    if(module.hot) {
      // 1752751711181
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  